module.exports = __webpack_public_path__ + "static/img/Malaysia.ea1bf85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Malaysia.png
// module id = umrC
// module chunks = 1